import Container from '@/components/layout/Container';
import ShortForm from './shortForm/shortForm';
import CustomerForm from './CustomerForm/customerForm';

export default function OptOutForm({ block, position }) {
  const { title, _metadata } = block?.opt_out_form ?? {};

  return (
    <section
      id={`${_metadata?.uid ?? 'opt-out-form'}_${position}`}
      data-name={'opt-out-form'}
      data-dd-privacy="mask-user-input"
      className="bg-warm-pewter-30 standard-padding"
    >
      <Container>
        <div className="mt-4">
          <ShortForm />
        </div>

        <div className="mt-4">
          <CustomerForm title={title} />
        </div>
      </Container>
    </section>
  );
}
